import React, {useEffect} from 'react';
import {Col, Row} from "reactstrap";
import Banner from "../../../../../assets/images/BreachRisk_Cloud_Integrations.svg";
import EarlyAccessWrapper from "../../../../../components/customBreachBits/settings/EarlyAccessWrapper";
import {useDispatch, useSelector} from "react-redux";
import {
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindCustomerTagsById, bbFindEntityWithinPortfolioOrSelf, bbFindUsersOnboardingProgress,
    bbFindUserTagsByTagId, bbFormattedDateString,
    isCurrentUserMemberOf,
    mapObject
} from "../../../../../util/bbHelpers";
import {fetchCloudIntegrationData, fetchCloudIntegrationOptions, setCustomerInView} from "../../../../../actions";
import TileCloudIntegration from "../../../../../components/customBreachBits/metrics/TileCloudIntegration";
import VerifiedOwnershipRequiredDialog
    from "../../../../../components/customBreachBits/OnboardingProgress/VerifiedOwnershipRequiredDialog";
import TileLoading from "../../../../../components/customBreachBits/metrics/TileLoading";
import BBIconCloudNetworkServer from "../../../../../assets/bbCustomIcons/BBIconCloudNetworkServer";
import OnboardingItemNotApplicableButton
    from "../../../../../components/customBreachBits/OnboardingProgress/OnboardingItemNotApplicable";
// import CloudIntegrationDataChart from "../../../../../components/customBreachBits/charts/CloudIntegrationDataChart";
import TileCloudIntegrationsData from "../../../../../components/customBreachBits/metrics/TileCloudIntegrationsData";
import BBIconCloudDatabase from "../../../../../assets/bbCustomIcons/BBIconCloudDatabase";
import BBIconCloudApp from "../../../../../assets/bbCustomIcons/BBIconCloudApp";
import BBIconCloudStorage from "../../../../../assets/bbCustomIcons/BBIconCloudStorage";
import BBIconCloudCompute from "../../../../../assets/bbCustomIcons/BBIconCloudCompute";
import CloudIntegrationDataStorageChart
    from "../../../../../components/customBreachBits/charts/CloudIntegrationDataStorageChart";
import CloudIntegrationDataDatabasesChart
    from "../../../../../components/customBreachBits/charts/CloudIntegrationDataDatabasesChart";
import CloudIntegrationDataAppsChart
    from "../../../../../components/customBreachBits/charts/CloudIntegrationDataAppsChart";
import CloudIntegrationDataComputeChart
    from "../../../../../components/customBreachBits/charts/CloudIntegrationDataComputeChart";
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import ActiveIntegrationTiles from "../../../../../components/customBreachBits/metrics/ActiveIntegrationTiles";
import {Button} from "@mui/material";
import ActiveIntegrationTileSection from "../../../../../components/customBreachBits/metrics/ActiveIntegrationTiles";

// export const testintegrationObject = {
//     "23e503d0-d6b4-4b9b-b007-506b7a885835": {
//         "id": "23e503d0-d6b4-4b9b-b007-506b7a885835",
//         "type": {
//             "id": 3,
//             "name": "Azure",
//             "description": "Include your Azure infrastructure to be discovered and tested by BreachBits.",
//             "available": true,
//             "logo_url": "https://resources.breachbits.co/logos/azure.png",
//             "documentation_url": "https://support.breachbits.com/knowledge/how-to-integrate-azure-with-breachbits"
//         },
//         "entity": "59ec40a5-6dc6-4d61-b1f9-740ddf9184b7",
//         "created_datetime": "2023-02-10T18:11:26",
//         "description": "Integration between Glenfarne AAD and BB",
//         "last_verified": "2023-05-25T18:25:14",
//         "has_error": false,
//         "error_message": null,
//         "is_active": true,
//         "deactivated_datetime": null,
//         "deactivated_by": null,
//         "deactivated_reason": null,
//         "registration_url": null
//     },
//     "c160b419-17c5-42aa-9d2a-02b6ee5dc18a": {
//         "id": "c160b419-17c5-42aa-9d2a-02b6ee5dc18a",
//         "type": {
//             "id": 2,
//             "name": "Amazon Web Services (AWS)",
//             "description": "Include your AWS infrastructure to be discovered and tested by BreachBits.",
//             "available": true,
//             "logo_url": "https://resources.breachbits.co/logos/aws.png",
//             "documentation_url": "https://support.breachbits.com/knowledge/how-to-integrate-aws-with-breachbits"
//         },
//         "entity": "36098bdd-d029-457f-b803-67f92c02f41f",
//         "created_datetime": "2022-05-03T18:07:44",
//         "description": null,
//         "last_verified": "2023-05-25T18:28:57",
//         "has_error": true,
//         "error_message": "Could not assume provided role for AWS integration. Please ensure the role (arn:aws:iam::517859433758:role/BreachRiskIntegrationRole) is still active. If not, please deactivate this integration and create a new AWS integration.",
//         "is_active": false,
//         "deactivated_datetime": null,
//         "deactivated_by": null,
//         "deactivated_reason": null,
//         "registration_url": null
//     },
//     "c160b419-17c5-42aa-9d2a-02b6ee5dc18b": {
//         "id": "c160b419-17c5-42aa-9d2a-02b6ee5dc18b",
//         "type": {
//             "id": 2,
//             "name": "Amazon Web Services (AWS)",
//             "description": "Include your AWS infrastructure to be discovered and tested by BreachBits.",
//             "available": true,
//             "logo_url": "https://resources.breachbits.co/logos/aws.png",
//             "documentation_url": "https://support.breachbits.com/knowledge/how-to-integrate-aws-with-breachbits"
//         },
//         "entity": "36098bdd-d029-457f-b803-67f92c02f41c",
//         "created_datetime": "2022-05-03T18:07:44",
//         "description": "Testing Active INTEGRATION",
//         "last_verified": "2023-05-25T18:28:57",
//         "has_error": false,
//         "error_message": null,
//         "is_active": true,
//         "deactivated_datetime": null,
//         "deactivated_by": null,
//         "deactivated_reason": null,
//         "registration_url": null
//     },
//     "c160b419-17c5-42aa-9d2a-02b6ee5dc18c": {
//         "id": "c160b419-17c5-42aa-9d2a-02b6ee5dc18c",
//         "type": {
//             "id": 2,
//             "name": "Amazon Web Services (AWS)",
//             "description": "Include your AWS infrastructure to be discovered and tested by BreachBits.",
//             "available": true,
//             "logo_url": "https://resources.breachbits.co/logos/aws.png",
//             "documentation_url": "https://support.breachbits.com/knowledge/how-to-integrate-aws-with-breachbits"
//         },
//         "entity": "36098bdd-d029-457f-b803-67f92c02f41f",
//         "created_datetime": "2022-05-03T18:07:44",
//         "description": "Active Integration for AWS",
//         "last_verified": "2023-05-25T18:28:57",
//         "has_error": false,
//         "error_message": null,
//         "is_active": true,
//         "deactivated_datetime": null,
//         "deactivated_by": null,
//         "deactivated_reason": null,
//         "registration_url": null
//     },
//     "23e503d0-d6b4-4b9b-b007-506b7a885835d": {
//         "id": "23e503d0-d6b4-4b9b-b007-506b7a885835d",
//         "type": {
//             "id": 3,
//             "name": "Azure",
//             "description": "Include your Azure infrastructure to be discovered and tested by BreachBits.",
//             "available": true,
//             "logo_url": "https://resources.breachbits.co/logos/azure.png",
//             "documentation_url": "https://support.breachbits.com/knowledge/how-to-integrate-azure-with-breachbits"
//         },
//         "entity": "59ec40a5-6dc6-4d61-b1f9-740ddf9184b7e",
//         "created_datetime": "2023-02-10T18:11:26",
//         "description": "Integration to keep testing active integrations",
//         "last_verified": "2023-05-25T18:25:14",
//         "has_error": true,
//         "error_message": "theres an error jim",
//         "is_active": true,
//         "deactivated_datetime": null,
//         "deactivated_by": null,
//         "deactivated_reason": null,
//         "registration_url": null
//     },
//     "23e503d0-d6b4-4b9b-b007-506b7a885835f": {
//         "id": "23e503d0-d6b4-4b9b-b007-506b7a885835f",
//         "type": {
//             "id": 3,
//             "name": "Azure",
//             "description": "Include your Azure infrastructure to be discovered and tested by BreachBits.",
//             "available": true,
//             "logo_url": "https://resources.breachbits.co/logos/azure.png",
//             "documentation_url": "https://support.breachbits.com/knowledge/how-to-integrate-azure-with-breachbits"
//         },
//         "entity": "59ec40a5-6dc6-4d61-b1f9-740ddf9184b7",
//         "created_datetime": "2023-02-10T18:11:26",
//         "description": "test test test test",
//         "last_verified": "2023-05-25T18:25:14",
//         "has_error": false,
//         "error_message": null,
//         "is_active": true,
//         "deactivated_datetime": null,
//         "deactivated_by": null,
//         "deactivated_reason": null,
//         "registration_url": null
//     },
// }

const CloudIntegrationPage = ({
                                portfolioView= false
                              }) => {
    const authUser = useSelector(({auth}) => auth.authUser);
    const {entityInView, portfolios, cloudIntegrations, loadingCloudIntegrations, loadingCloudIntegrationsError, loadingCloudIntegrationData, loadingCloudIntegrationDataError} = useSelector(({breachrisk}) => breachrisk);
    const {didJustRegisterCloudIntegration, didJustUnregisterCloudIntegration } = useSelector(({breachrisk}) => breachrisk.appMisc);
    const {customers, customerInView,} = useSelector(({customer}) => customer);
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);

    const userOnboardingProgress = myEntity && bbFindUsersOnboardingProgress(myEntity, authUser);

    const completedOnboardingItems = userOnboardingProgress && userOnboardingProgress.filter(item => item.value === true).length;
    const totalOnboardingItems = userOnboardingProgress && userOnboardingProgress.length;
    const percentOnboardingComplete = userOnboardingProgress ? (completedOnboardingItems/totalOnboardingItems) * 100 : 0;

    const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    const dispatch = useDispatch();
    useEffect( () => {
        //if there are no integrations, fetch them
        if (entityInView
            && (!cloudIntegrations || (cloudIntegrations && !cloudIntegrations[entityInView]))
            && !loadingCloudIntegrations[entityInView]
            && isTrustedAgentForThisEntity
        ) {
            dispatch(fetchCloudIntegrationOptions(entityInView));
        }
    }, [dispatch, authUser, portfolios, entityInView, cloudIntegrations, loadingCloudIntegrations, loadingCloudIntegrationsError, ]);


    // console.log("Cloud integrations state is", cloudIntegrations);

    const cloudOptions = cloudIntegrations && cloudIntegrations[entityInView] && cloudIntegrations[entityInView].options;
    const cloudIntegrationObjects = cloudIntegrations
        && cloudIntegrations[entityInView]
        && cloudIntegrations[entityInView].integrations;
    // const cloudIntegrationObjects = testintegrationObject;
    const cloudIntegrationData = cloudIntegrations && cloudIntegrations[entityInView] && cloudIntegrations[entityInView].integrations && cloudIntegrations[entityInView].integrationData;

    // console.log("Registering new integrations should trigger useeffect for collecting integration data: cloudIntegrationObjects", cloudIntegrationObjects, "also check cloud integration loading states, jsut in case", loadingCloudIntegrations, loadingCloudIntegrationsError, "loading cloud integration data", loadingCloudIntegrationData, loadingCloudIntegrationDataError);
    useEffect(()=>{
        // if(hasEarlyAccess){
            if( !loadingCloudIntegrations[entityInView]
                && !loadingCloudIntegrationsError[entityInView]
                && cloudIntegrationObjects
                && Object.keys(cloudIntegrationObjects).length > 0
                && !loadingCloudIntegrationData[entityInView]
                && !loadingCloudIntegrationDataError[entityInView]
                // && !cloudIntegrationData
            ){
                //needs to call for each integration type that's present in Object.keys(cloudIntegrationsOjbects)
                const integrationIds = Object.values(cloudIntegrationObjects).filter((object)=> object.is_active)
                // integrationIds.push("c160b419-17c5-42aa-9d2a-02b6ee5dc18a")
                console.log("useeffect for initial load of integration data, integrationIds is", integrationIds, "look at loadingCLoudIntegrationData", loadingCloudIntegrationData)

                const queryTypes = ["storage", "compute", "databases", "apps"]

                for (const id of integrationIds){
                    const description = id
                    && id.description
                        ? id.description
                        : `${id && id.type && id.type.name} added ${bbFormattedDateString(id.created_datetime, "monthYear")}`;

                    for(const query of queryTypes){
                        console.log("gonna get data for entity", entityInView, "with integration id", id.id, "and query type", query)
                        dispatch(fetchCloudIntegrationData(entityInView, id.id, query, description))
                    }
                }
            }
        // }
            },[cloudIntegrationObjects, loadingCloudIntegrationsError, loadingCloudIntegrationDataError, loadingCloudIntegrationData, loadingCloudIntegrations])

    useEffect(()=>{
        if((didJustRegisterCloudIntegration || didJustUnregisterCloudIntegration)
            && !cloudIntegrationData){

            const integrationIds = Object.values(cloudIntegrationObjects).filter((object)=> object.is_active)
            const queryTypes = ["storage", "compute", "databases", "apps"]
            console.log("a cloud integraiton was added or removed, rerunning calls for associated data")

            for (const object of integrationIds){
                const description = object
                && object.description
                    ? object.description
                    : `${object && object.type && object.type.name} added ${bbFormattedDateString(object.created_datetime, "monthYear")}`;

                for(const query of queryTypes){
                    console.log("gonna get data for entity", entityInView, "with integration id", object.id, "and query type", query,)
                    dispatch(fetchCloudIntegrationData(entityInView, object.id, query, description))
                }
            }
        }
    }, [didJustRegisterCloudIntegration, didJustUnregisterCloudIntegration])

    // console.log("CloudIntegrationData, ", cloudIntegrationData, "loadingCloudIntegrationData", loadingCloudIntegrationData, "loadingCloudIntegrationDataError", loadingCloudIntegrationDataError, "didJustRegister", didJustRegisterCloudIntegration, "didUnregister", didJustUnregisterCloudIntegration)

    const cloudIntegrationsSection =
        // <EarlyAccessWrapper>
        <Row id={"tourCloudIntegration"}>
            {cloudOptions && Object.values(cloudOptions).map((option, index) => {
                // console.log("Loo0ing at cloud Options", cloudOptions, option)
                return <Col key={`cloudOptionKey${option.id}`} id={`tourCloudIntegration${index}`}>
                    <TileCloudIntegration integrationOption={option} integrationObjects={cloudIntegrationObjects} portfolioView={portfolioView}/>
                </Col>
            })}
        </Row>
    // </EarlyAccessWrapper>


    return(
        <div className="app-wrapper">
            <div className="animated fadeIn animation-duration-7">
                <div className="row">
                    <div className={"col-8 align-self-center"}>
                        <div className={"mx-0 px-0"}>
                            <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>
                        </div>
                    </div>
                    <div className={"col-4 align-self-center"}>
                        <h3>Automatic verifications and attestations.</h3>
                        <p>If you have infrastructure in the cloud, there is no easier way to keep your verifications updated while improving your fidelity.</p>

                    </div>
                </div>
                <hr/>
                {(portfolioView && (isStaffAdmin || isTrustedAgentForThisEntity)) || !portfolioView
                    ?
                    <VerifiedOwnershipRequiredDialog>
                    <h1 id={"tourCloudIntegrationsStepOne"}>Register A Cloud Integration</h1>
                    <p>Automatically synchronize your cloud-based infrastructure to further increase fidelity.
                        <small className={"float-right align-self-center"}><OnboardingItemNotApplicableButton text={"No Cloud Integrations?"} progressItem={"enabledCloudIntegrations"}/></small>
                    </p>

                    {(!entityInView || !portfolios) || (entityInView && loadingCloudIntegrations[entityInView])
                        ? <Row id={"tourCloudIntegration"}>
                            <Col>
                                <TileLoading subtitle={"Digital Ocean"} icon={<BBIconCloudNetworkServer style={{fontSize: "70px"}}/>}/>
                            </Col>
                            <Col>
                                <TileLoading subtitle={"AWS"}icon={<BBIconCloudNetworkServer style={{fontSize: "70px"}}/>}/>
                            </Col>
                            <Col>
                                <TileLoading subtitle={"Microsoft Azure"} icon={<BBIconCloudNetworkServer style={{fontSize: "70px"}}/>}/>
                            </Col>
                        </Row>
                        : cloudIntegrationsSection
                    }
                    <hr/>
                    <section id={"ActiveIntegrationsSection"}>
                        <Row>
                            <Col>
                                <h1 id={"ActiveIntegrationsHeader"}>
                                    Active Integrations
                                </h1>
                            </Col>
                            {/*{cloudIntegrationObjects*/}
                            {/*&& Object.values(cloudIntegrationObjects)*/}
                            {/*    .filter((object) => !object.is_active)*/}
                            {/*    .length > 0*/}
                            {/*    ?<Col sm={2} md={2} lg={2}>*/}
                            {/*    <Button onClick*/}
                            {/*        color={"primary"} */}
                            {/*            variant={"contained"}>*/}
                            {/*        Show Inactive Integrations*/}
                            {/*    </Button>*/}
                            {/*</Col>*/}
                            {/*    : null}*/}
                        </Row>
                        <Row>
                            <Col id={"ActiveIntegrationsSubheader"}>
                                <p>
                                    View cloud integrations you've added to your BreachRisk&trade; service.
                                </p>
                            </Col>
                        </Row>
                        <section id={"ActiveIntegrationsTiles"}>
                            {cloudIntegrationObjects
                                && <ActiveIntegrationTileSection
                                    arrayOfIntegrationObjects={Object.values(cloudIntegrationObjects).filter((object)=> object.is_active)}
                                />}
                        </section>
                    </section>
                        <hr/>

                    {/*<EarlyAccessWrapper>*/}
                        <section id={"tourCloudIntegrationsStepOne"}>
                            <h1>All Resources Accessible to Cloud Integrations</h1>
                            <p>See information synchronized from your cloud-based infrastructure.</p>

                            <Row id={"tourCloudDataHeader"}>
                                <Col>
                                    <TileCloudIntegrationsData queryType={"apps"} icon={<BBIconCloudApp style={{fontSize: "70px"}}/>} />
                                </Col>
                                <Col>
                                    <TileCloudIntegrationsData queryType={"storage"} icon={<BBIconCloudStorage style={{fontSize: "70px"}}/>}/>
                                </Col>
                                <Col>
                                    <TileCloudIntegrationsData queryType={"compute"} icon={<BBIconCloudCompute style={{fontSize: "70px"}}/>}/>
                                </Col>
                                <Col>
                                    <TileCloudIntegrationsData queryType={"databases"} icon={<BBIconCloudDatabase style={{fontSize: "70px"}}/>}/>
                                </Col>
                            </Row>

                            <Row id={"tourBRCloudAppsChart"}>

                                <Col>
                                    <CloudIntegrationDataAppsChart/>
                                </Col>
                            </Row>

                            <Row id={"tourBRCloudStorageChart"}>
                                <Col>
                                    <CloudIntegrationDataStorageChart/>

                                </Col>
                            </Row>

                            <Row id={"tourBRCloudComputeChart"}>
                                <Col>
                                    <CloudIntegrationDataComputeChart/>
                                </Col>
                            </Row>

                            <Row id={"tourBRCloudDatabasesChart"}>
                                <Col>
                                    <CloudIntegrationDataDatabasesChart/>

                                </Col>
                            </Row>
                        </section>
                    {/*</EarlyAccessWrapper>*/}

                </VerifiedOwnershipRequiredDialog>

                : <>
                        <br/>
                        <br/>
                        <br/>
                        <Tooltip title={"If you need these details, this company will need to approve a request."} link={`https://support.breachbits.com/knowledge/requesting-access`}>
                            <h2 className={"text-center"}>You don't have Trusted Agent privileges for this Entity <InfoSharpIcon/></h2>
                        </Tooltip>

                        <br/>
                        <br/>

                    </>}

            </div>
        </div>

    )
}

export default CloudIntegrationPage;